const RatesMock = [
  {
    id: 1,
    carrier: '[HC] XYZ Shipping Co.',
    level: '[HC] Bronze',
    transit_time: '10 Days [HC]',
    estimated_delivery: 'JAN 11, 2019 [HC]',
    rate: '$120.00 [HC]',
    accessorial: '$40.00 [HC]',
    transit: '$40.00 [HC]',
    fuel: '$40.00 [HC]'
  },
  {
    id: 2,
    carrier: '[HC] XXXXXXXX Shipping Co.',
    level: '[HC] Bronze',
    transit_time: '7 - 10 Days [HC]',
    estimated_delivery: 'JAN 5 - 8, 2019 [HC]',
    rate: '$124.00 [HC]',
    accessorial: '$40.00 [HC]',
    transit: '$40.00 [HC]',
    fuel: '$40.00 [HC]'
  },
  {
    id: 3,
    carrier: '[HC] Example Shipping Co.',
    level: '[HC] Bronze',
    transit_time: '10 Days [HC]',
    estimated_delivery: 'JAN 11, 2019 [HC]',
    rate: '$132.00 [HC]',
    accessorial: '$40.00 [HC]',
    transit: '$40.00 [HC]',
    fuel: '$40.00 [HC]'
  },
  {
    id: 4,
    carrier: '[HC] XYZ Shipping Co.',
    level: '[HC] Bronze',
    transit_time: '7 Days [HC]',
    estimated_delivery: '[HC] JAN 11, 2019',
    rate: '$135.00 [HC]',
    accessorial: '$40.00 [HC]',
    transit: '$40.00 [HC]',
    fuel: '$40.00 [HC]'
  }
];

export const NewRate = {
  carrier: '',
  quoteId: '',
  level: '',
  transit_time: '',
  estimated_delivery: '',
  rate: '',
  notes: '',
  isVolumeRate: false
};

export default RatesMock;
